var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"drop-box"},[_c('CommonDrop',{ref:"drop",attrs:{"url":"/trade/customer/list","autoDefault":false,"disabled":_vm.disabled,"clearable":_vm.clearable,"size":"mini","filterable":true},model:{value:(_vm.currentValue),callback:function ($$v) {_vm.currentValue=$$v},expression:"currentValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }